import { CellProps } from 'react-table'
import { GenerateAsoActionsCell } from './GenerateAsoActionsCell'
import { AtendimentoList } from '../../../../atendimento/core/_models'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useListView } from '../../core/ListViewProvider'
import {
  PlainHeader,
  SelectionCell,
  SelectionHeader,
  sortableColumn,
  StackedCell,
  TableColumn,
} from '../../../../../../components'
import { TFunction } from '_metronic/i18n/Metronici18n'

// Mesmas colunas da tela de assinatura (aso-sign-list), com ações de edição/geração.
export const GenerateAsoColumns = (t: TFunction): ReadonlyArray<TableColumn<AtendimentoList>> => [
  {
    Header: (props) => (
      <SelectionHeader
        useListView={useListView}
        tableProps={props}
        ariaLabel='Selecionar todos desta página'
      />
    ),
    id: 'selection',
    cellWidth: '48px',
    Cell: ({ row }: CellProps<AtendimentoList>) => (
      <SelectionCell
        useListView={useListView}
        id={row.original.id}
        ariaLabel={`Selecionar ASO ${row.original.protocolo ?? ''}`}
      />
    ),
  },
  // Paciente com a instituição dele como apoio; os dois seguem ordenáveis.
  sortableColumn<AtendimentoList>({
    id: 'paciente.pessoa.nome',
    useQueryRequest,
    fields: [
      { field: 'paciente.pessoa.nome', label: t('cols.paciente') },
      { field: 'paciente.empresa.nomeFantasia', label: t('empresa.label') },
    ],
    Cell: ({ row }: CellProps<AtendimentoList>) => (
      <StackedCell
        primary={row.original.paciente?.pessoa?.nome}
        secondary={row.original.paciente?.empresa?.nomeFantasia}
      />
    ),
  }),
  sortableColumn<AtendimentoList>({
    id: 'protocolo',
    cellWidth: '160px',
    useQueryRequest,
    fields: [{ field: 'protocolo', label: t('cols.protocolo') }],
    Cell: ({ row }: CellProps<AtendimentoList>) => (
      <StackedCell tabular primary={row.original.protocolo} />
    ),
  }),
  sortableColumn<AtendimentoList>({
    id: 'estado.descricao',
    cellWidth: '160px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'estado.descricao', label: t('cols.estado') }],
    Cell: ({ row }: CellProps<AtendimentoList>) => (
      <StackedCell primary={row.original.estado?.descricao} />
    ),
  }),
  // Data da solicitação (ordem padrão: mais recente primeiro); o backend já manda formatada.
  sortableColumn<AtendimentoList>({
    id: 'solicitacao',
    cellWidth: '168px',
    useQueryRequest,
    fields: [{ field: 'solicitacao', label: t('cols.data') }],
    Cell: ({ row }: CellProps<AtendimentoList>) => (
      <StackedCell tabular primary={row.original.solicitacaoFormatada} />
    ),
  }),
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<AtendimentoList>) => (
      <GenerateAsoActionsCell atendimento={row.original} />
    ),
  },
]
